// 页面中部欢迎用户的提示组件

import { motion } from "framer-motion";
import { ChatSuggest } from "./ChatSuggest";

interface OverviewProps {
  onSendMessage?: (message: string) => void;
}

export const Overview = ({ onSendMessage }: OverviewProps) => {
  return (
    <motion.div
      key="overview"
      className="min-w-[21.4375rem] w-full h-full flex justify-center items-center"
    >
      <div className="bg-[var(--overview-background)] p-6 flex flex-col gap-4 text-sm border-border text-center">
        <p className="text-[var(--overview-title-color)] font-bold text-[1.75rem]">
          嗨！我是匹配与决策智能体引擎系统V1.0
        </p>
        <p className="text-[var(--overview-text-color)] text-base">
          您可以使用AI智能助手来管理您的货运订单,创建新订单,找货等
        </p>
        <p className="text-[var(--overview-text-color)] text-base">
          您可以在任何时间,任何地点使用AI智能助手
        </p>
        <ChatSuggest onSendMessage={onSendMessage} />
      </div>
    </motion.div>
  );
};
